import { toast } from "react-toastify";
import axios, { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import Cookies from "js-cookie";

const baseURL = process.env.REACT_APP_API_URL;
const apiCode = process.env.REACT_APP_API_CODE;

const apiHeader = () => {
  return {
    "api-code": apiCode,
    token: Cookies.get("Token"),
  };
};

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (error && error.response) {
    const data: any = error.response.data;
    toast.error(data.Message);
  }
  return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}

class ApiClass {
  get(url: string, baseUrl?: string) {
    return axios.get(`${baseUrl || baseURL}${url}`, { headers: apiHeader() });
  }

  post(url: string, data: { [name: string]: any }) {
    return axios.post(`${baseURL}${url}`, data, { headers: apiHeader() });
  }

  delete(url: string) {
    return axios.delete(`${baseURL}${url}`, { headers: apiHeader() });
  }

  put(url: string, data: { [name: string]: any }) {
    return axios.put(`${baseURL}${url}`, data, { headers: apiHeader() });
  }

  sPost(url: string, data: any) {
    return axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        TimeoutMilliseconds: 600000,
      },
      auth: {
        password: "!@#123qweQ",
        username: "S.karami",
      },
    });
  }
}

setupInterceptorsTo(axios);

const Api = new ApiClass();

export default Api;
